export default __webpack_public_path__ + "static/media/BG-LightBlue-0000.db2e1b9c.png";